var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-badge',_vm._b({},'el-badge',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }